module Meevo.Plugins.EventSchedule {
  "use strict";

  /**
  * Main Section  
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EventSchedule> {
    /**
    * Base class override which defines what a DEFAULT model looks like.
    */

      constructor(
          sectionId: number,
          displayNameContentKey: string,
          template: string,
          isPrimarySection: boolean,
          handlesOwnCrud: boolean,
          baseEndpoint: string,
          sectionEndpoint: string,
          loggingService: Meevo.Components.Logging.ILoggingService,
          dataService: Meevo.Components.BaseClasses.IDataService,
          identityService: Meevo.Components.Common.IIdentityService = null,
          noun: Meevo.Model.NounEnum = null,
          appSettings: Components.Common.IAppSettings,
          protected modalService: Meevo.Components.Modal.IModalService,
          sectionSecurityKey?: string
      ) {
          super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey)
      }



    createSectionModelInstance(postAdd:(data:any)=>any): void {
        this.dataService.getTemplate(this.baseEndpoint).then((data) => {
            this.model = data;

            if (this.identityService.inCentralOfficeMode() && Model.Guard.isSomething(this.identityService.current().userBusinessTypeIds)) {

                var _userAssignedBT: Model.DataDetail[] = [];
                var _BT: Model.DataDetail;
                for (const key in this.identityService.current().userBusinessTypeIds) {
                    const value = this.identityService.current().userBusinessTypeIds[key]
                    _userAssignedBT.push({ id: key, displayName: value })

                }
                if (_userAssignedBT.length > 0) {
                    this.model.businessTypeDetail = { id: _userAssignedBT[0].id, displayName: _userAssignedBT[0].displayName };
                 }

            }
            
        });
      }

    

  }
}